<template>
<!-- eslint-disable-->
  <div id="personCenterTable">
    <div class="conditions">
      <el-select v-if="select" class="conditions-select"
                 v-model="select.value"
                 :placeholder="select.placeholder"
                 :multiple="select.multiple"
                 collapse-tags
                 @change="handleSelectChange">
        <el-option v-for="(option, idx) in select.options"
                   :label="option.label"
                   :value="option.value"
                   :key="option.value"/>
      </el-select>
      <el-date-picker
          @change="handleDateChange"
          class="conditions-date-picker"
          v-if="datePicker"
          v-model="datePicker.value"
          type="daterange"
          align="center"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd">
      </el-date-picker>
      <el-input v-if="input"
                @change="handleInputChange"
                class="conditions-input"
                :placeholder="input.placeholder"
                v-model="input.value"
                prefix-icon="el-icon-search">
      </el-input>
    </div>
    <el-table
        :data="table.data"
        style="width: 100%"
        v-loading="table.loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 0.3)">
      <slot name="tableColumn"></slot>
    </el-table>
    <el-pagination
        v-if="!paginationDisabled"
        style="background-color: #ffffff;padding: 5px 0;text-align: center;"
        @current-change="handlePageChange"
        :page-size="table.pageSize"
        :layout="$isMobile ? 'total, prev, next, jumper' : 'total, prev, pager, next, jumper'"
        :total="table.total"
        :current-page.sync="table.pageNum">
    </el-pagination>

  </div>
</template>

<script>
import personCenterTableMixin from "@/pages/userCenter/Mixins/PersonCenterTableMixin";

export default {
  name: "personCenterTable",
  mixins: [personCenterTableMixin]
}
</script>

<style lang="less">
#personCenterTable {
  .conditions {
    display: flex;
    justify-content: space-between;
    .conditions-select {
      flex: 2;
    }
    .conditions-date-picker {
      flex: 3;
    }
    .conditions-input {
      flex: 2;
    }
  }
}
</style>